module.exports = __webpack_public_path__ + "img/lg_ring_skip_skip_0_1@2x.38e62b9b.png";